import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SystemSecurityUpdateGoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"system_security_update_good"}/>
}
